import queryString from 'query-string';
import {
  AD_ERRORS,
  BASKET_ERRORS_TYPE,
  JJ_APOLLO,
  POSTCODE_REGEX,
  PRODUCT_DESCRIPTION_REGEX,
  RESERVED_WORD,
  ROUTES,
} from '../constants/constants';

export const getItemPlural = itemLength => (itemLength > 1 ? `items` : 'item');

export const getPlural = itemLength => (itemLength > 1 ? `are` : 'is');

export const getCancelOrEdit = cancel => (cancel ? `cancel` : 'edit');

export const formatPostcode = postCode => {
  let parts = postCode.match(POSTCODE_REGEX);
  if (parts && parts.length > 0) {
    parts.shift();
    return parts.join(' ').toUpperCase();
  } else {
    return postCode.toUpperCase();
  }
};

export const wrapLongDescription = description =>
  description.replace(PRODUCT_DESCRIPTION_REGEX, '($1) ');

export const getBasketErrorMessage = type => {
  let message = 'Product cannot be added';
  switch (type) {
    case BASKET_ERRORS_TYPE.PAYMENT_TYPE:
      message = 'Payment cannot be updated';
      break;
    case BASKET_ERRORS_TYPE.REMOVE:
      message = 'Product cannot be remove';
      break;
    case BASKET_ERRORS_TYPE.UPDATE:
      message = 'Basket cannot be update';
      break;
    case BASKET_ERRORS_TYPE.SLOT_EXPIRED:
    case BASKET_ERRORS_TYPE.SLOT_EXPIRED_DURING_CHECKOUT:
      message = 'Order cannot be processed';
  }
  return message;
};

export const getTopBarWelcomeText = (
  profile,
  isStaffAccount,
  email,
  isLoggedIn,
  isSSRCookie
) => {
  if (isSSRCookie) {
    return `Welcome ${decodeURIComponent(isSSRCookie)}`;
  }
  let message = `Welcome to JJ's online store`;
  if (!isLoggedIn) {
    return message;
  }
  if (isStaffAccount && !profile && email) {
    message = `Welcome ${email}`;
  } else if (profile && profile.name !== RESERVED_WORD.PRIVATE) {
    message = `Welcome ${profile.name || profile.tradingName}`;
  } else {
    message = 'Welcome back';
  }
  return message;
};

export const getLoginError = error => {
  if (
    error &&
    error.details &&
    error.details.indexOf(AD_ERRORS.LOGIN_CANCELLED) > -1
  ) {
    return 'You have NOT completed the registration process. Log back in to pick up registration where you left off.';
  }
  return error.details || error;
};

// The order id from a confirmation page path such as
// `/confirmation/<orderId>`; null when the path has no id. The id is used as a
// path segment in the orders API, so it must not carry a leading slash.
export const getOrderIdFromConfirmationPath = pathname => {
  if (typeof pathname !== 'string') {
    return null;
  }
  const match = pathname.match(/\/confirmation\/+([^/?#]+)/);
  return match ? match[1] : null;
};

export const getCallbackUrlFromUrl = routeString => {
  const fullUrl = routeString.split('/confirmation/');
  if (fullUrl.length !== 2) {
    return null;
  }
  const param = fullUrl[1].split('?');
  const queryParams = queryString.parse(param[1]);
  if (param[0]) {
    return `?basketUuid=${param[0]}&callback=${queryParams.callback}`;
  }
};

export const getBackButtonText = route => {
  let pageName = 'Search Results';
  if (route === ROUTES.FAVOURITES) {
    pageName = 'Favourites';
  }
  if (route === ROUTES.RECENT_PURCHASES) {
    pageName = 'Recent Purchases';
  }
  if (route === ROUTES.OFFERS) {
    pageName = 'My Offers';
  }
  if (route === ROUTES.SHOPPING_LISTS_CONTENT) {
    pageName = 'My Shopping Lists';
  }
  return ` Back To ${pageName} `;
};

export const capitalizeString = string => {
  const lowerCasedString = (string || '').toLowerCase();
  return lowerCasedString.charAt(0).toUpperCase() + lowerCasedString.slice(1);
};

export const generateAppRedirectHtml = (
  url,
  appUrl,
  sessionStorageData,
  options = {}
) => {
  const sessionStorageItems = sessionStorageData
    ?.map(item => {
      if (!item.value) {
        return '';
      }
      const safeKey = JSON.stringify(item.key);
      const safeValue = JSON.stringify(item.value);
      return `if (${safeKey}.length > 0 && ${safeValue}.length > 0) {
      sessionStorage.setItem(${safeKey}, JSON.stringify(${safeValue}));
    };\n\n`;
    })
    .join('');

  const sharedStyles = `
        body { text-align: center; font-family: "Open Sans", sans-serif; -webkit-font-smoothing: antialiased; }
        h1 {
            line-height: 1.15;
            -webkit-text-size-adjust: 100%;
            box-sizing: border-box;
            margin: .67em 0;
            color: rgb(38, 174, 93);
            text-transform: capitalize;
            font-size: 2.6rem;
            font-weight: lighter;
            display: inline-block;
            padding-left: 1rem;
            padding-right: 1rem;
            text-align: center;
        }
        p {
          -webkit-text-size-adjust: 100%;
          text-align: center;
          box-sizing: border-box;
          color: rgb(121, 121, 121);
          font-size: 1.6rem;
          line-height: 2.4rem;
        }
        .btn {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          text-decoration: none;
          cursor: pointer;
          color: #fff;
          background-color: rgb(38, 174, 93);
          border: 0.2rem solid rgb(38, 174, 93);
          font-size: 1.4rem;
          font-weight: bold;
          text-transform: uppercase;
          height: 5rem;
          outline: none;
          padding: 0 2rem;
          border-radius: 0.4rem;
          margin: 1rem auto;
          min-width: 60%;
        }
        .btn-secondary {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          text-decoration: none;
          cursor: pointer;
          color: rgb(38, 174, 93);
          background-color: transparent;
          border: 0.2rem solid rgb(38, 174, 93);
          font-size: 1.4rem;
          font-weight: bold;
          text-transform: uppercase;
          height: 4rem;
          outline: none;
          padding: 0 1rem;
          max-width: 60%;
          margin: 0.5rem auto;
        }`;

  if (options.isAndroid) {
    return `<html lang='en'>
    <head>
      <title>Redirecting...</title>
      <style>${sharedStyles}</style>
    </head>
    <body>
    <script>${sessionStorageItems || ''}</script>
    <h1>Open in App</h1>
    <p><a class='btn' href='${appUrl}'>Open JJ Food Service</a></p>
    <p><a class='btn-secondary' href='${url}'>Continue in browser instead</a></p>
</body></html>`;
  }

  return `<html lang='en'>
    <head>
      <title>Redirecting...</title>
      <style>${sharedStyles}</style>
    </head>
    <body>
    <h1>Please wait...</h1>
    <script>
    ${sessionStorageItems}
    var appOpened = false;
    var fallbackTimer;

    document.addEventListener('visibilitychange', function() {
        if (document.hidden || document.webkitHidden) {
            appOpened = true;
            clearTimeout(fallbackTimer);
        }
    });

    // If neither the app nor a fallback took over, the page is still showing:
    // continue in the browser.
    fallbackTimer = setTimeout(function() {
        if (!appOpened) {
            window.location.href = '${url}';
        }
    }, 2000);

    const isAndroid = /android/i.test(navigator.userAgent);
    if (isAndroid) {
        // Android: an intent:// URL, whose fallback Chrome opens itself when
        // the app isn't installed. Browsers without intents (Firefox, desktop
        // Chrome emulating a phone) fail to launch it and stay here, so the
        // timer above still takes them on.
        const appPath = '${appUrl}'.replace('jjfoodservice://', '');
        window.location.href = 'intent://' + appPath + '#Intent;scheme=jjfoodservice;S.browser_fallback_url=' + encodeURIComponent('${url}') + ';end';
    } else {
        // iOS: click the custom URL scheme link. Safari shows an alert if the
        // app is not installed; the user taps OK and the fallback timer redirects.
        var appLink = document.createElement('a');
        appLink.setAttribute('href', '${appUrl}');
        document.body.appendChild(appLink);
        appLink.click();
        document.body.removeChild(appLink);
    }
    </script>
    <p><a class='btn-secondary' href='${url}'>Continue in browser instead</a></p>
</body></html>`;
};

export const generateCodeVerifierHtml = (
  url,
  sessionStorageData,
  debugHost
) => {
  const sessionStorageItems = sessionStorageData
    ?.map(item => {
      if (!item.value) {
        return '';
      }
      const safeKey = JSON.stringify(item.key);
      const safeValue = JSON.stringify(item.value);
      return `if (${safeKey}.length > 0 && ${safeValue}.length > 0) {
      sessionStorage.setItem(${safeKey}, JSON.stringify(${safeValue}));
    };\n\n`;
    })
    .join('');

  return `<html lang='en'>
    <head>
      <title>Redirecting....</title>
      <style>
        body { text-align: center; }
        h1 {
            line-height: 1.15;
            -webkit-text-size-adjust: 100%;
            font-family: "Open Sans", sans-serif;
            -webkit-font-smoothing: antialiased;
            box-sizing: border-box;
            margin: .67em 0;
            color: rgb(38, 174, 93);
            text-transform: capitalize;
            font-size: 2.6rem;
            font-weight: lighter;
            display: inline-block;
            padding-left: 1rem;
            padding-right: 1rem;
            text-align: center;
        }
        p {
          -webkit-text-size-adjust: 100%;
          font-family: "Open Sans", sans-serif;
          -webkit-font-smoothing: antialiased;
          text-align: center;
          box-sizing: border-box;
          color: rgb(121, 121, 121);
          font-size: 1.6rem;
          line-height: 2.4rem;
        }
        p a {
          line-height: 1.15;
          -webkit-text-size-adjust: 100%;
          font-family: "Open Sans", sans-serif;
          -webkit-font-smoothing: antialiased;
          box-sizing: border-box;
          display: flex;
          -webkit-box-align: center;
          align-items: center;
          -webkit-box-pack: center;
          justify-content: center;
          text-decoration: none;
          cursor: pointer;
          color: rgb(38, 174, 93);
          background-color: transparent;
          border: 0.2rem solid rgb(38, 174, 93);
          font-size: 1.4rem;
          font-weight: bold;
          text-transform: uppercase;
          height: 4rem;
          outline: none;
          text-align: center;
          padding: 0px 1rem;
          max-width: 60%;
          margin: 0 auto;
        }
      </style> 
    </head>
    <body>
    <h1>Please wait...</h1>
    <script>
    ${sessionStorageItems}
    window.location.href = '${url}';
    </script>
    <p><a href='${url}'>Click here if you are not redirected automatically</a></p>
</body></html>`;
};

export const generateAppLink = (req, options = {}) => {
  const query = queryString.stringify(req.query);
  const pathSegments = (req.params[0] || '').split('/');
  const routeKey = pathSegments[0].toUpperCase();
  const fullParams = pathSegments.slice(1);
  const screen = fullParams[0] ? '/' + fullParams[0] : '';
  const params = fullParams[1] ? '/' + fullParams[1] : '';
  const apolloRoute = JJ_APOLLO.ROUTES[routeKey] || `/${pathSegments[0]}`;
  const path = `${apolloRoute}${screen}${params}`;
  const queryStr = query ? '?' + query : '';
  if (options.isAndroid && options.webFallbackUrl) {
    const encodedFallback = encodeURIComponent(options.webFallbackUrl);
    return `intent://${path}${queryStr}#Intent;scheme=jjfoodservice;S.browser_fallback_url=${encodedFallback};end`;
  }
  return `${JJ_APOLLO.URI}${path}${queryStr}`;
};

export const getAvailableAtDateString = dateArray => {
  if (!dateArray || (dateArray && !dateArray[1] && dateArray[2])) {
    return '';
  }
  const day = dateArray[2] < 10 ? '0' + dateArray[2] : dateArray[2];
  const month = dateArray[1] < 10 ? '0' + dateArray[1] : dateArray[1];
  return 'Available from ' + day + '/' + month;
};

export const capitalize = s =>
  (s && String(s[0]).toUpperCase() + String(s).slice(1)) || '';

export const markdownConvert = str => {
  if (!str) {
    return '';
  }
  return str
    .replace(/<span\s+class="([^"]*)"[^>]*>(.*?)<\/span>/g, '$2')
    .replace(/<a\s+(?:[^>]*?\s+)?href="([^"]*)"[^>]*>(.*?)<\/a>/g, '[$2]($1)')
    .replace(
      /<img\s+(?:[^>]*?\s+)?src="([^"]*)"[^>]*\s*alt="([^"]*)"\s*\/?>/g,
      '![$2]($1)'
    )
    .replace(/<br\s*\/?\s*>/g, '  \n');
};

export const getInvoiceApiUrl = originalUrl => {
  // Already routed through the gateway — prefixing again would give
  // /api/invoice/api/invoice/...
  if (originalUrl.indexOf('/api/invoice/') > -1) {
    return originalUrl;
  }
  // olympus local return the non api url
  const url = new URL(originalUrl);
  const modifiedPath = `/api/invoice${url.pathname}`;
  return `${url.origin}${modifiedPath}`;
};
